<setup>
    <div class="modal {state.showApplyConfirmation ? 'active' : ''}"
         role="dialog"
         aria-modal="true"
         aria-hidden={!state.showApplyConfirmation}
         aria-labelledby="setup-apply-dialog-title">
        <a class="modal-overlay" href="#close" role="button" aria-label="Tutup konfirmasi" onclick={closeApplyConfirmation}></a>
        <div class="modal-container setup-confirmation-modal">
            <div class="modal-header">
                <button class="btn btn-clear float-right" aria-label="Tutup" disabled={state.loading} onclick={closeApplyConfirmation}></button>
                <div class="modal-title h5" id="setup-apply-dialog-title">Konfirmasi Terapkan Data</div>
            </div>
            <div class="modal-body">
                <div class="content">
                    <p>Data awal yang sudah divalidasi akan diterapkan.</p>
                    <p class="text-gray">Data yang tidak tercantum tidak akan dihapus.</p>
                    <div if={state.showApplyConfirmation && state.message && !state.success} class="toast toast-error">
                        {state.message}
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn" disabled={state.loading} onclick={closeApplyConfirmation}>Batal</button>
                <button id="setup-confirm-apply"
                        class="btn btn-success loading-{state.loading}"
                        disabled={state.loading || !state.preview || !state.preview.valid}
                        onclick={confirmApply}>Terapkan Data</button>
            </div>
        </div>
    </div>

    <div class="container setup-page">
        <h2>Data Awal</h2>
        <p class="text-gray">Kelola tahun ajaran, jenis kehadiran, dan penempatan siswa. Data yang tidak dicantumkan tidak akan dihapus.</p>

        <div if={state.message} class="toast toast-{state.success ? 'success' : 'error'}">
            <button class="btn btn-clear float-right" onclick={clearMessage}></button>
            {state.message}
        </div>

        <section>
            <div class="section-title">
                <h4>Tahun Ajaran</h4>
                <button class="btn btn-sm" onclick={addAcademicYear}>Tambah</button>
            </div>
            <div class="columns row-gap" each={(item, index) in state.academicYears}>
                <div class="column col-9 col-sm-12">
                    <input class="form-input" value={item.label} placeholder="Contoh: 2026/2027 - Semester 1" oninput={(event) => editAcademicYear(index, event)}>
                </div>
                <div class="column col-3 col-sm-12">
                    <button class="btn btn-error btn-sm" onclick={() => removeAcademicYear(index)}>Keluarkan</button>
                </div>
            </div>
        </section>

        <section>
            <div class="section-title">
                <h4>Jenis Kehadiran</h4>
                <button class="btn btn-sm" onclick={addAttendanceType}>Tambah</button>
            </div>
            <div class="columns row-gap" each={(item, index) in state.attendanceTypes}>
                <div class="column col-7 col-sm-12">
                    <input class="form-input" value={item.label} placeholder="Contoh: Sakit" oninput={(event) => editAttendanceType(index, event)}>
                </div>
                <div class="column col-2 col-sm-12">
                    <input class="form-input color-input" type="color" value={item.color} title="Warna grafik" oninput={(event) => editAttendanceColor(index, event)}>
                </div>
                <div class="column col-3 col-sm-12">
                    <button class="btn btn-error btn-sm" onclick={() => removeAttendanceType(index)}>Keluarkan</button>
                </div>
            </div>
        </section>

        <section>
            <div class="section-title">
                <h4>Siswa</h4>
                <div>
                    <a class="btn btn-sm" href="/api/v1/setup/students/template" target="_blank" download>Unduh Template</a>
                    <button class="btn btn-sm btn-primary" onclick={triggerImportSiswa}>Impor Data</button>
                    <input type="file" id="import-siswa-file" style="display: none" accept=".csv,.xlsx" onchange={handleImportSiswa}>
                </div>
            </div>
            <div if={state.students && state.students.length > 0} class="toast toast-primary">
                {state.students.length} siswa siap diimpor dari file.
                <button class="btn btn-clear float-right" aria-label="Batal" onclick={clearImportSiswa}></button>
            </div>
            <div if={!state.students || state.students.length === 0} class="text-gray">
                Belum ada data siswa yang siap diimpor.
            </div>
        </section>

        <div class="action-bar">
            <button class="btn btn-primary loading-{state.loading}" disabled={state.loading} onclick={preview}>Validasi & Pratinjau</button>
            <button class="btn btn-success" disabled={!state.preview || !state.preview.valid || state.loading} onclick={apply}>Terapkan Data</button>
        </div>

        <section if={state.preview}>
            <h4>Hasil Pratinjau</h4>
            <div class="toast toast-{state.preview.valid ? 'success' : 'error'}">
                {state.preview.valid ? 'Data valid dan siap diterapkan.' : 'Perbaiki kesalahan sebelum menerapkan data.'}
                Buat: {state.preview.summary.create}, ubah: {state.preview.summary.update}, tetap: {state.preview.summary.unchanged}.
            </div>
            <div class="table-scroll" tabindex="0" role="region" aria-label="Data awal">
                <table class="table table-striped">
                    <thead><tr><th>Jenis</th><th>Baris</th><th>Kunci</th><th>Aksi</th><th>Keterangan</th></tr></thead>
                    <tbody>
                        <tr each={item in state.preview.items}>
                            <td>{entityLabel(item.entity)}</td>
                            <td>{item.index + 1}</td>
                            <td>{item.key}</td>
                            <td><span class="label label-{actionClass(item.action)}">{actionLabel(item.action)}</span></td>
                            <td>{(item.errors || []).join('; ')}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>
    </div>

    <style>
        setup section { margin-top: 2rem; }
        setup .section-title { align-items: center; display: flex; justify-content: space-between; margin-bottom: .6rem; }
        setup .section-title h4 { margin: 0; }
        setup .row-gap { margin-bottom: .4rem; }
        setup .action-bar { display: flex; gap: .5rem; margin-top: 2rem; }
        setup .table-scroll { overflow-x: auto; }
        setup table { min-width: 760px; }
        setup .color-input { height: 2rem; padding: .1rem; }
        setup .setup-confirmation-modal { max-width: 30rem; }
        setup .setup-confirmation-modal .modal-body p:last-of-type { margin-bottom: 0; }
        setup .setup-confirmation-modal .toast { margin-top: 1rem; }
    </style>

    <script>
        const defaultColors = ['#16A34A', '#F59E0B', '#2563EB', '#DC2626', '#7C3AED', '#0891B2']

        export default {
            state: {
                academicYears: [],
                attendanceTypes: [],
                classes: [],
                students: [],
                preview: null,
                loading: false,
                message: '',
                success: false,
                showApplyConfirmation: false,
            },
            onMounted() {
                this.applyConfirmationKeydownHandler = event => this.closeApplyConfirmationOnEscape(event)
                window.addEventListener('keydown', this.applyConfirmationKeydownHandler)
                Promise.all([
                    axios.get('/api/v1/academic-years'),
                    axios.get('/api/v1/attendance/types'),
                    axios.get('/api/v1/classes'),
                ]).then(([years, types, classes]) => this.update({
                    academicYears: (years.data.items || []).map(item => ({label: item.label})),
                    attendanceTypes: (types.data.items || []).map((item, index) => ({label: item.label, color: item.color || defaultColors[index % defaultColors.length]})),
                    classes: classes.data.items || [],
                })).catch(error => this.fail(error, 'Data referensi tidak dapat dimuat'))
            },
            onBeforeUnmount() {
                window.removeEventListener('keydown', this.applyConfirmationKeydownHandler)
            },
            changed() { this.update({preview: null, message: ''}) },
            addAcademicYear(event) { event.preventDefault(); this.state.academicYears.push({label: ''}); this.changed() },
            removeAcademicYear(index) { this.state.academicYears.splice(index, 1); this.changed() },
            editAcademicYear(index, event) { this.state.academicYears[index].label = event.target.value; this.changed() },
            addAttendanceType(event) { event.preventDefault(); this.state.attendanceTypes.push({label: '', color: defaultColors[this.state.attendanceTypes.length % defaultColors.length]}); this.changed() },
            removeAttendanceType(index) { this.state.attendanceTypes.splice(index, 1); this.changed() },
            editAttendanceType(index, event) { this.state.attendanceTypes[index].label = event.target.value; this.changed() },
            editAttendanceColor(index, event) { this.state.attendanceTypes[index].color = event.target.value; this.changed() },
            payload() {
                const nonEmpty = item => Object.values(item).some(value => String(value || '').trim())
                return {
                    academicYears: this.state.academicYears.filter(nonEmpty),
                    attendanceTypes: this.state.attendanceTypes.filter(item => String(item.label || '').trim()),
                    students: this.state.students.filter(nonEmpty),
                }
            },
            triggerImportSiswa(event) {
                event.preventDefault()
                const input = document.getElementById('import-siswa-file')
                if (input) input.click()
            },
            handleImportSiswa(event) {
                const file = event.target.files[0]
                if (!file) return

                const formData = new FormData()
                formData.append('file', file)

                this.update({loading: true, message: ''})
                axios.post('/api/v1/setup/students/import', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                }).then(response => {
                    this.update({
                        students: response.data.items || [],
                        success: true,
                        message: `${(response.data.items || []).length} siswa berhasil dibaca dari file`
                    })
                    this.changed()
                }).catch(error => {
                    this.fail(error, 'Gagal mengimpor file siswa')
                }).finally(() => {
                    this.update({loading: false})
                    event.target.value = '' // reset file input
                })
            },
            clearImportSiswa(event) {
                if (event) event.preventDefault()
                this.update({students: []})
                this.changed()
            },
            preview(event) {
                event.preventDefault()
                this.update({loading: true, message: ''})
                axios.post('/api/v1/setup/preview', this.payload())
                    .then(response => {
                        const submittedStudents = this.state.students.filter(item => Object.values(item).some(value => String(value || '').trim()))
                        for (const item of response.data.items || []) {
                            if (item.entity === 'studentAssignment' && submittedStudents[item.index]) {
                                submittedStudents[item.index].alternativeID = item.key
                            }
                        }
                        this.update({preview: response.data})
                    })
                    .catch(error => this.fail(error, 'Pratinjau gagal dibuat'))
                    .finally(() => this.update({loading: false}))
            },
            apply(event) {
                event.preventDefault()
                if (!this.state.preview || !this.state.preview.valid) return
                this.applyTrigger = event.currentTarget
                this.update({showApplyConfirmation: true, message: ''})
                window.requestAnimationFrame(() => {
                    const confirmButton = document.getElementById('setup-confirm-apply')
                    if (confirmButton) confirmButton.focus()
                })
            },
            closeApplyConfirmation(event) {
                if (event) event.preventDefault()
                if (this.state.loading) return
                this.update({showApplyConfirmation: false})
                if (this.applyTrigger) {
                    this.applyTrigger.focus()
                    this.applyTrigger = null
                }
            },
            closeApplyConfirmationOnEscape(event) {
                if (event.key === 'Escape' && this.state.showApplyConfirmation) {
                    this.closeApplyConfirmation(event)
                }
            },
            confirmApply(event) {
                event.preventDefault()
                if (this.state.loading || !this.state.preview || !this.state.preview.valid) return
                this.update({loading: true, message: ''})
                axios.post('/api/v1/setup/apply', this.payload())
                    .then(response => this.update({
                        preview: response.data,
                        success: true,
                        showApplyConfirmation: false,
                        message: `Data berhasil diterapkan: ${response.data.summary.create} dibuat, ${response.data.summary.update} diubah, ${response.data.summary.unchanged} tetap.`,
                    })).then(() => { this.applyTrigger = null })
                    .catch(error => {
                        if (error.response && error.response.status === 422) this.update({preview: error.response.data})
                        this.fail(error, 'Data tidak dapat diterapkan')
                    }).finally(() => this.update({loading: false}))
            },
            fail(error, fallback) {
                const message = error.response && error.response.data && error.response.data.message
                this.update({message: message || fallback, success: false})
            },
            clearMessage() { this.update({message: ''}) },
            entityLabel(entity) { return ({academicYear: 'Tahun ajaran', attendanceType: 'Jenis kehadiran', studentAssignment: 'Siswa/kelas', students: 'Siswa'})[entity] || entity },
            actionLabel(action) { return ({create: 'Buat', update: 'Ubah', unchanged: 'Tetap'})[action] || '-' },
            actionClass(action) { return ({create: 'success', update: 'warning', unchanged: 'secondary'})[action] || 'error' },
        }
    </script>
</setup>
